import StoreOrderDetail from '../dashboard/StoreOrderDetail';

export default function AdminStoreOrderDetail() {
  return <StoreOrderDetail adminMode />;
}
